import styled from 'styled-components'
import { Spacing } from 'cio-design-library/design-tokens'
import Media from 'builder/styles/media'

export const WrapperSelect = styled.div`
  margin-top: 20px;
  ${Media.AbovePhone`
    margin-top: ${Spacing.L};
  `}
`

export const WrapperButtons = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
  gap: ${Spacing['2XS']};
  margin-top: ${Spacing.M};
  ${Media.AbovePhone`
    margin-top: ${Spacing.L};
  `}
`
